import { Apple, Play } from "lucide-react";

const Badge = ({ icon: Icon, top, bottom, dark, testid }) => (
  <div
    data-testid={testid}
    title="Download links coming soon"
    className={`flex items-center gap-3 rounded-2xl px-5 py-3 border cursor-default select-none hover:-translate-y-0.5 transition-transform duration-300 ${
      dark
        ? "bg-white/10 border-white/20 text-white"
        : "bg-diem-ink text-white border-diem-ink shadow-[0_10px_28px_rgba(15,23,42,0.25)]"
    }`}
  >
    <Icon className="w-7 h-7" />
    <span className="text-left leading-tight">
      <span className="block text-[10px] font-semibold uppercase tracking-wider opacity-70">{top}</span>
      <span className="block font-display text-lg font-semibold tracking-tight">{bottom}</span>
    </span>
  </div>
);

export const StoreBadges = ({ dark = false }) => (
  <div className="flex flex-wrap gap-3" data-testid="store-badges">
    <Badge icon={Apple} top="Download on the" bottom="App Store" dark={dark} testid="app-store-badge" />
    <Badge icon={Play} top="Get it on" bottom="Google Play" dark={dark} testid="google-play-badge" />
  </div>
);
